$mol_button_typed $mol_button
	minimal_height 40
	minimal_width 40
